// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"923":"2b85b1ec","2840":"a0cf56ad","4061":"92032edf","4774":"92032edf","4789":"2b85b1ec","4794":"2b85b1ec","7264":"37cf3500","8204":"2b85b1ec","9181":"2b85b1ec"}[chunkId] + ".chunk.css";
};